"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@turajs/util");
const countCodePages_1 = require("./countCodePages");
const countDataPages_1 = require("./countDataPages");
function calculateMinimumCreationFee(args) {
    const { dataHex, codeHex } = args;
    const codePagesCount = codeHex ? countCodePages_1.countCodePages(codeHex) : 0;
    const dataPagesCount = dataHex && dataHex.length ? countDataPages_1.countDataPages(dataHex) : 1;
    return util_1.Amount.fromPlanck(util_1.FeeQuantPlanck * 10 * (2 + codePagesCount + dataPagesCount));
}
exports.calculateMinimumCreationFee = calculateMinimumCreationFee;
//# sourceMappingURL=calculateMinimumCreationFee.js.map